import React from "react";

import "bootstrap/dist/css/bootstrap.min.css";

const FullstackVideoCard_2 = () => {
  return (
    <div className="card w-50 h-auto">
      <div className="card-body bg-dark text-white">
        <h5 className="card-title">OEE App tracker</h5>
        <p className="card-text">
          I build this application for one of my lines where I managed the maintenance department.
          The porposue of this APP is to track real time OEE, every data was loaded on a Postgress data base that
          can be local hosted or on the cloud. The App was made using ReactJS.
        </p>

        <h6>
          Investment: <span>$8,000 USD</span>
        </h6>
        <h6>
          Time to build: <span>6 months</span>
        </h6>
        <h6>
          Technology: <span>ReactJS, Postgress, NodeJS.
          </span>
        </h6>
      </div>
    </div>
  );
};

export default FullstackVideoCard_2;
